import { PAYMENTS_SECTIONS_ROUTES } from '@/models/app-internal/permissions.model';

export enum ENV_VAR_NAMES {
  APP_MODE = 'APP_MODE',
  MOCKS_ENABLED = 'MOCKS_ENABLED',
  BACKOFFICE_API_URL = 'BACKOFFICE_API_URL',
  WL_SLUG = 'WL_SLUG',
  BONUS_PERMISSIONS = 'BONUS_PERMISSIONS',
  CURRENT_PARTENT_ROUTE_NAME = 'CURRENT_PARTENT_ROUTE_NAME',
  MULTIBRAND_API_URL = 'MULTIBRAND_API_URL',
  MULTIBRAND_API_HOST = 'MULTIBRAND_API_HOST',
  WHITELABEL_ID = 'WHITELABEL_ID',
}

export type EnvConfig = {
  [ENV_VAR_NAMES.MOCKS_ENABLED]: string;
  [ENV_VAR_NAMES.BACKOFFICE_API_URL]: string;
  [ENV_VAR_NAMES.WL_SLUG]: string;
  [ENV_VAR_NAMES.CURRENT_PARTENT_ROUTE_NAME]: string;
  [ENV_VAR_NAMES.MULTIBRAND_API_URL]: string;
  [ENV_VAR_NAMES.MULTIBRAND_API_HOST]: string;
  [ENV_VAR_NAMES.WHITELABEL_ID]: string;
};

export type EnvVariables = Record<string, string | undefined>;

export const DEFAULT_PROPS = (): Props => {
  return {
    apiUrl: '',
    wlSlug: '',
    multibrandApiUrl: '',
    currentParentRouteName: '',
    servicePermissions: '',
    whitelabelId: '',
  };
};

export type Props = {
  apiUrl: string;
  wlSlug: string;
  multibrandApiUrl: string;
  currentParentRouteName: string;
  servicePermissions: string;
  whitelabelId: string;
}

export type DefaultProps = {
  apiUrl: Props['apiUrl'];
  multibrandApiUrl: Props['multibrandApiUrl'];
  wlSlug: Props['wlSlug'];
  currentParentRouteName: Props['currentParentRouteName'];
  servicePermissions: Props['servicePermissions'];
  whitelabelId: Props['whitelabelId'];
}

export type PARENT_ROUTE_NAMES = '' | PAYMENTS_SECTIONS_ROUTES;
/* Указываем все дочерние роуты этого микрофронта
для каждого из них создаем enum — один подраздел, один enum
export type PARENT_ROUTE_NAMES = '' | OTHER_ROUTE_NAMES | SOME_OTHER_ROUTE_NAMES;
*/
